import { render, staticRenderFns } from "./tableFieldSamples.vue?vue&type=template&id=a140d230&scoped=true"
import script from "./tableFieldSamples.vue?vue&type=script&lang=js"
export * from "./tableFieldSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a140d230",
  null
  
)

export default component.exports